const ICONS_COLORS = 'gray';
const COLOR_OPTIONS = 'transparent';
const SHAPE_OPTIONS = 'square';
const FONT_SIZE_OPTIONS = 'font-light';
const ICON_3D_OPTIONS = '';

export { COLOR_OPTIONS as C, FONT_SIZE_OPTIONS as F, ICONS_COLORS as I, SHAPE_OPTIONS as S, ICON_3D_OPTIONS as a };
